

<template>
<div class="logo">
  <img src="@/assets/GalstianLogo.png" id="LogoGal">
</div>
  <LinkBox/>
  
</template>


<script>
import LinkBox from './components/LinkBox.vue';

export default {
  name: 'App',
  components: {
    LinkBox,
  }
};
</script>

<style>

#LogoGal {
  width: 10em;
 height: auto; /* Set a fixed height */
}

#app {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
  background-position: center center;
  background: radial-gradient(110.35% 110.35% at 50% -10.35%, rgba(205, 162, 116, 0.14) 25.24%, rgba(246, 193, 136, 0.09) 69.56%, rgba(100, 79, 57, 0.07) 83%, rgba(0, 0, 0, 0.00) 100%), url('@/assets/Image 3.png') lightgray 50% / cover no-repeat;
      min-height: 100vh;
     
.logo{
  padding-top: 1em;
}

    }

.buttons-column {
  display: flex;
  flex-direction: column;

}
</style>
